document.addEventListener("DOMContentLoaded", () => {
  const sectionWrapper = document.getElementById("section-wrapper");

  const product_id = sectionWrapper.dataset.productId;
  const product_price = sectionWrapper.dataset.price;
  const addToCartText = sectionWrapper.dataset.addToCartText;
  const chooseColorText = sectionWrapper.dataset.chooseColorText;

  let build_a_box_data = null;

  // KEENSLIDER
  function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active")
        })
      }
      
      function addActive(idx) {
        slider.slides[idx].classList.add("active")
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx)
          })
        })
      }

      slider.on("created", () => {
        addActive(slider.track.details.rel)
        addClickEvents()
        main.on("animationStarted", (main) => {
          removeActive()
          const next = main.animator.targetIdx || 0
          addActive(main.track.absToRel(next))
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
        })
      })
    };
  }

  const product_slider_slides = sectionWrapper.querySelectorAll(".keen-slider__slide");
  product_slider_slides.forEach((slide) => {
    slide.classList.remove("hidden", "mr-[10px]");
  });

  const product_large_slider = new KeenSlider(
    "#product-keen-large-slider", 
    {
      loop: false,
      slides: {
        spacing: 8,
        perView: 1.1,
      },
    }
  );

  const product_thumbnails_slider = new KeenSlider(
    "#product-keen-thumbnail-slider",
    {
        loop: false,
        slides: {
          spacing: 10,
          perView: 6,
        },
        vertical: false,
    },
    [ThumbnailPlugin(product_large_slider)]
  );

  // GUARANTEE POPUP BLOCK (ON PRODUCT PAGE)
  const guarantee_popup_open_button = document.getElementById("block-guarantee-popup-open-button");
  const guarantee_popup_wrapper = document.getElementById("block-guarantee-popup-wrapper");
  const guarantee_popup_close_button = document.getElementById("block-guarantee-popup-close-button");

  if (guarantee_popup_open_button && guarantee_popup_wrapper) {
    guarantee_popup_open_button.addEventListener("click", () => {
      guarantee_popup_wrapper.classList.remove("hidden");
    });
  }

  if (guarantee_popup_close_button && guarantee_popup_wrapper) {
    guarantee_popup_close_button.addEventListener("click", () => {
      guarantee_popup_wrapper.classList.add("hidden");
    });
  }

  // COLOR PICKER SLIDER
  (function () {
    const el = document.querySelector(".color-list-slider-wrapper");
    if (!el) return;

    const bar = document.querySelector(".color-list-scrollbar");
    const track = bar.querySelector(".track");
    const thumb = bar.querySelector(".thumb");

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let rafId = 0;
    let momentumRunning = false;

    const stopMomentum = () => {
      momentumRunning = false;
      cancelAnimationFrame(rafId);
    };

    const momentum = () => {
      momentumRunning = true;

      if (Math.abs(velocity) < 0.01) {
        momentumRunning = false;
        return;
      }
      el.scrollLeft -= velocity * 12;
      velocity *= 0.95;

      updateThumb();
      rafId = requestAnimationFrame(momentum);
    };

    el.addEventListener("dragstart", (e) => e.preventDefault());

    el.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      isDown = true;
      el.classList.add("grabbing");

      bar.classList.add("active");

      startX = e.clientX;
      startScrollLeft = el.scrollLeft;
      velocity = 0;
      lastX = e.clientX;
      lastTime = Date.now();
      stopMomentum();
    });

    window.addEventListener(
      "mousemove",
      (e) => {
        if (!isDown) return;
        e.preventDefault();
        const dx = e.clientX - startX;
        el.scrollLeft = startScrollLeft - dx;

        const now = Date.now();
        const dt = now - lastTime;
        if (dt > 0) velocity = (e.clientX - lastX) / dt;
        lastX = e.clientX;
        lastTime = now;

        updateThumb();
      },
      { passive: false }
    );

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      el.classList.remove("grabbing");

      setTimeout(() => bar.classList.remove("active"), 120);

      if (Math.abs(velocity) > 0.08) momentum();
    };

    window.addEventListener("mouseup", endDrag);
    el.addEventListener("mouseleave", endDrag);

    function updateThumb() {
      const cw = el.clientWidth;
      const sw = el.scrollWidth;
      const sl = el.scrollLeft;

      if (sw <= cw) {
        thumb.style.width = "0px";
        thumb.style.transform = "translateX(0)";
        return;
      }

      const trackW = track.clientWidth;
      const minThumb = 40;
      const thumbW = Math.max((cw / sw) * trackW, minThumb);
      const maxLeft = trackW - thumbW;
      const left = (sl / (sw - cw)) * maxLeft;

      thumb.style.width = thumbW + "px";
      thumb.style.transform = `translateX(${left}px)`;
    }

    function syncBarWidth() {
      //const rect = el.getBoundingClientRect();
      //bar.style.width = rect.width + 'px';
      updateThumb();
    }

    el.addEventListener(
      "scroll",
      () => {
        updateThumb();
      },
      { passive: true }
    );

    window.addEventListener("resize", syncBarWidth);

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => syncBarWidth());
      ro.observe(el);
      ro.observe(track);
    } else {
      setTimeout(syncBarWidth, 60);
    }

    syncBarWidth();
    setTimeout(syncBarWidth, 250);
  })();

  // CUSTOM STICKY ATC BUTTON
  const stickyButtonWrapper = document.querySelector('.byteex-stycky-atc-button-wrapper');
  const stickyButton = document.getElementById('byteex-stycky-atc-button');
  const stickyButtonText = document.getElementById('sticky_atc_button_text');
  const nail_picker = document.getElementById('nail_picker');
  const submitButton = document.getElementById('pick-your-colors-button');

  if (stickyButtonWrapper && stickyButtonText && submitButton) {
    const scrollToElement = (el, offset = 0) => {
      const targetY = el.getBoundingClientRect().top + window.scrollY - offset;
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      } else {
        window.scrollTo(0, targetY);
      }
    };

    if (submitButton.getAttribute('type') === 'button') {
      stickyButtonText.innerText = chooseColorText;
    } else {
      stickyButtonText.innerText = addToCartText;
    }

    stickyButtonWrapper.addEventListener('click', () => {
      scrollToElement(nail_picker, 200);
    });

    const checkButtonPosition = () => {
      const currentSubmitButton = document.getElementById('pick-your-colors-button');
      const buttonRect = currentSubmitButton.getBoundingClientRect();
      if (buttonRect.bottom <= 70) {
        stickyButtonWrapper.style.transform = 'translateY(0px)';
      } else {
        stickyButtonWrapper.style.transform = 'translateY(140px)';
      }
    };

    window.addEventListener('scroll', checkButtonPosition);

    stickyButton.addEventListener('click', (event) => {
      event.stopPropagation();
      const stickyLoader = document.getElementById('sticky_atc_button_loader');
      const loaderDisplayStyle = window.getComputedStyle(stickyLoader).display;
      const currentSubmitButton = document.getElementById('pick-your-colors-button');

      scrollToElement(nail_picker, 200);

      if (currentSubmitButton.getAttribute('type') === 'submit' && loaderDisplayStyle === 'none') {
        currentSubmitButton.click();
      }      
    });

    const buttonObserver = new MutationObserver(() => {
      const button = document.getElementById('pick-your-colors-button');
      if (!button) return;
      if (button.getAttribute('type') === 'submit') {
        stickyButtonText.innerText = addToCartText;
      } else {
        stickyButtonText.innerText = chooseColorText;
      }
    });

    buttonObserver.observe(submitButton, { attributes: true });
  }

  // TWO VIDEO BLOCK
  const two_video_block_button_1 = document.getElementById("two-video-block-button-1");
  const two_video_block_button_2 = document.getElementById("two-video-block-button-2");
  const two_video_block_video_1 = document.getElementById("two-video-block-video-1");
  const two_video_block_video_2 = document.getElementById("two-video-block-video-2");

  if (two_video_block_button_1 && two_video_block_button_2 && two_video_block_video_1 && two_video_block_video_2) {
    two_video_block_button_1.addEventListener("click", () => {
      two_video_block_video_1.classList.remove("hidden");
      two_video_block_video_2.classList.add("hidden");
      two_video_block_button_1.style.borderBottom = "thin solid #211912";
      two_video_block_button_2.style.borderBottom = "none";
    });

    two_video_block_button_2.addEventListener("click", () => {
      two_video_block_video_1.classList.add("hidden");
      two_video_block_video_2.classList.remove("hidden");
      two_video_block_button_1.style.borderBottom = "none";
      two_video_block_button_2.style.borderBottom = "thin solid #211912";
    });
  }

  fetch("https://api.skio.com/storefront-http/get-dynamic-box", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ productPlatformId: product_id }),
  })
    .then((response) => response.json())
    .then((data) => {
      build_a_box_data = data;
      console.log('Build a box data ----------------------', build_a_box_data);

      const hidden_overlay = document.getElementById("hidden-overlay");
      const pick_your_colors_button = document.getElementById("pick-your-colors-button");
      const pick_your_colors_button_price = pick_your_colors_button.querySelector(".price");
      const pick_your_colors_button_compare_price = pick_your_colors_button.querySelector(".compare-price");

      const variant_picker_items_element = document.getElementById("variant-picker-items");
      const pre_selected_variant_number = parseInt(variant_picker_items_element.dataset.preSelectedVariantNumber);

      const variant_picker_items = document.querySelectorAll(".variant-picker-item");
      let max_number_of_wraps = 0;
      let min_number_of_wraps = 10;
      let current_number_of_wraps = 0;
      const build_a_box_id = build_a_box_data.DynamicBox.boxId;    

      const selling_plans_data = build_a_box_data.DynamicBox.sellingPlanGroup;
      const selling_plans_ids = Object.entries(selling_plans_data)
        .sort(([, a], [, b]) => a.position - b.position)
        .map(([key, value]) => ({
          id: key.split("/").pop(),
          discount: value.priceAdjustmentAmount,
          interval: value.interval,
          interval_count: value.intervalCount,
          title: value.title,
        }));

      let selected_selling_plan_id = selling_plans_ids[pre_selected_variant_number - 1].id;
      let selected_selling_plan_title = selling_plans_ids[pre_selected_variant_number - 1].title;
      
      const color_items = document.querySelectorAll(".nail-picker-color");

      let selected_colors_array = [];

      const price_per_wrap_elements = document.querySelectorAll(".price-per-wrap");
      const variant_price_elements = document.querySelectorAll(".variant-price");
      const discount_percentage_elements = document.querySelectorAll(".discount-percentage");
      const price_block_loader_element = document.querySelector(".price-block-loader");
      const price_block_content_elements = document.querySelectorAll(".price-block-content");
      const price_block_elements = document.querySelectorAll(".price-block");    

      const nail_picker_title_wraps_number = document.getElementById("nail-picker-title-wraps-number");

      const nail_picker_selected_colors = document.querySelectorAll(".nail-picker-selected-color");
      const color_list_selected_colors = document.querySelectorAll(".color-list-selected-color");

      const selected_colors_sticky_atc = document.querySelectorAll('.byteex-stycky-atc-selected-color'); 

      const build_a_box_gift_items = document.querySelectorAll(".build-a-box-gift-item");

      const subscription_percent_element = document.getElementById("subscription-percent");
      const subscription_wraps_number_element = document.getElementById("subscription-wraps-number");
      const subscription_term_element = document.getElementById("subscription-term");
      const subscription_price_per_wrap_element = document.getElementById("subscription-price-per-wrap");
      const subscription_picker_first_item = document.querySelector(".subscription-picker-first-item");

      const nail_picker_color_list_wrapper = document.getElementById("nail-picker-color-list-wrapper");

      const nail_picker_color_list_close_popup = document.querySelectorAll(".nail-picker-color-list-close-popup");

      const selected_colors_last_step = document.querySelectorAll('.selected-colors-last-step');

      const variant_message_element = document.getElementById('variant-message'); 

      const add_color_plus_buttons = document.querySelectorAll(".color-item-count-plus");
      const add_color_plus_buttons_popup = document.querySelectorAll(".nail-picker-color-popup-add-button");

      // GET FREE COUNT FROM VARIANT TITLE
      function getFreeCount(str) {
        const match = str.match(/\+\s*(\d+)/);
        return match ? Number(match[1]) : null;
      }

      let selected_discount_percent = 0;
      if (Object.values(build_a_box_data.DynamicBox.percentDiscountTier).length === 1) {
        selected_discount_percent = Object.values(build_a_box_data.DynamicBox.percentDiscountTier)[0];
      }

      // VARIANT PICKER ITEMS
      variant_picker_items.forEach((item, i, arr) => {
        const number_of_wraps = parseInt(item.dataset.numberOfWraps);
        const variant_title = item.dataset.title;
        const message = item.dataset.message;
        //const subscription_percent = selling_plans_ids[i].discount;

        let discount_percent;
        if (!selected_discount_percent) {
          for (const tier in build_a_box_data.DynamicBox.percentDiscountTier) {
            if (+tier === number_of_wraps) {
              discount_percent = build_a_box_data.DynamicBox.percentDiscountTier[tier];
            }
          }
        } else {
          discount_percent = selected_discount_percent;
        }

        const per_set_price =
          Math.round(((product_price - (product_price * discount_percent) / 100) / 100) * 100) / 100;

        price_per_wrap_elements[i].textContent = per_set_price;
        variant_price_elements[i].textContent = (per_set_price * number_of_wraps).toFixed(2);
        discount_percentage_elements[i].textContent = discount_percent;

        // set the max number of wraps and the price per wrap
        if (number_of_wraps > max_number_of_wraps) {
          max_number_of_wraps = number_of_wraps;
          max_per_set = per_set_price;
        }

        // set the min number of wraps
        if (number_of_wraps < min_number_of_wraps) {
          min_number_of_wraps = number_of_wraps;
        }

        if (i === 0) {
          pick_your_colors_button_price.textContent = (per_set_price * number_of_wraps).toFixed(2);
          pick_your_colors_button_compare_price.textContent = ((product_price * number_of_wraps) / 100).toFixed(2);
        }

        // add event listener to the variant picker item
        item.addEventListener("click", () => {
          current_number_of_wraps = number_of_wraps;
          selected_discount_percent = discount_percent;

          if (variant_message_element) { 
            variant_message_element.textContent = message;
          }

          // update subscription percent, wraps number, term and price per wrap on subscription block
          subscription_percent_element.textContent = discount_percent;
          subscription_wraps_number_element.textContent = current_number_of_wraps;        
          subscription_price_per_wrap_element.textContent = per_set_price;

          const interval_count = selling_plans_ids[i].interval_count;
          if (interval_count > 1) {
            subscription_term_element.textContent = `${interval_count} ${selling_plans_ids[i].interval}s`;
          } else {
            subscription_term_element.textContent = `${interval_count} ${selling_plans_ids[i].interval}`;
          }

          selected_selling_plan_id = selling_plans_ids[i].id;
          selected_selling_plan_title = selling_plans_ids[i].title;

          // set the wraps number in the selected colors title
          nail_picker_title_wraps_number.textContent = number_of_wraps;

          // get free count from variant title
          const freeCount = getFreeCount(variant_title);

          // update selected colors
          nail_picker_selected_colors.forEach((color, index) => {
            const lock_icon = color.querySelector(".lock-icon");
            const plus_icon = color.querySelector("span");
            const image = color.querySelector("img");
            const image_wrapper = color.firstElementChild;
            const remove_icon = color.querySelector(".remove-selected-color");
            const default_title = color.dataset.defaultTitle;
            const color_name = color.querySelector("p");

            if (index > number_of_wraps - 1) {
              lock_icon.classList.remove("hidden");
              plus_icon.classList.add("hidden");
              image.classList.add("hidden");
              image.removeAttribute("src");
              remove_icon.classList.add("hidden");
              color_name.textContent = default_title;
              color.removeAttribute("data-id");

              image_wrapper.style.backgroundColor = "#FAF7F5";
              image_wrapper.style.borderColor = "#2119124D";
            } else {
              lock_icon.classList.add("hidden");
              if (!image.src) {
                plus_icon.classList.remove("hidden");
              }

              image_wrapper.style.backgroundColor = "#ffffff";
              image_wrapper.style.borderColor = "#211912B2";
            }

            // ADD FREE LABEL TO MAIN SELECTED COLOR
            const free_label = color.querySelector('.nail-picker-selected-color-free-label');
            if (freeCount && index <= current_number_of_wraps - 1 && index >= current_number_of_wraps - freeCount) {
              free_label.style.display = 'block';
            } else {
              free_label.style.display = 'none';
            }
          });

          // update selected colors array
          selected_colors_array = [];
          nail_picker_selected_colors.forEach(color => {
            const id = color.dataset.id;

            if (id) {
              selected_colors_array.push(id);
            }
          });

          // update selected colors on picker on color items list
          color_items.forEach((color) => {
            const id = color.dataset.variantId;
            const color_item_count = color.querySelector(".color-item-count");

            if (selected_colors_array.includes(id)) {
              const color_count = checkSelectedColor(id);              
              color_item_count.textContent = color_count;
            } else {
              color.querySelector(".quantity-color-item-wrapper").classList.add("hidden");
              const current_color_img = color.querySelector('.nail-picker-color-image-wrapper');
              current_color_img.classList.remove('selected-color-item');
              color_item_count.textContent = 0;
            }
          });

          // update selected colors on picker
          color_list_selected_colors.forEach((color, index) => {
            const lock_icon = color.querySelector(".lock-icon");
            const plus_icon = color.querySelector("span");
            const image = color.querySelector("img");

            if (index > number_of_wraps - 1) {
              lock_icon.classList.remove("hidden");
              plus_icon.classList.add("hidden");
              image.classList.add("hidden");
              image.removeAttribute("src");
              color.removeAttribute("data-id");

              color.style.backgroundColor = "#FAF7F5";
              color.style.borderColor = "#2119124D";
            } else {
              lock_icon.classList.add("hidden");
              if (!image.src) {
                plus_icon.classList.remove("hidden");
              }

              color.style.backgroundColor = "#ffffff";
              color.style.borderColor = "#211912B2";
            }
          });

          // update selected colors on sticky atc
          selected_colors_sticky_atc.forEach((color, index) => {
            const lock_icon = color.querySelector(".lock-icon");
            const plus_icon = color.querySelector("span");
            const image = color.querySelector("img");

            if (index > number_of_wraps - 1) {
              lock_icon.classList.remove("hidden");
              plus_icon.classList.add("hidden");
              image.classList.add("hidden");
              image.removeAttribute("src");

              color.style.backgroundColor = "#FAF7F5";
              color.style.borderColor = "#2119124D";
            } else {
              lock_icon.classList.add("hidden");
              if (!image.src) {
                plus_icon.classList.remove("hidden");
              }

              color.style.backgroundColor = "#ffffff";
              color.style.borderColor = "#211912B2";
            }
          });

          // set price for selected variant
          price_block_elements.forEach((element) => {
            element.style.display = "none";
          });
          price_block_elements[i].style.display = "block";

          // update price for selected variant on atc button
          pick_your_colors_button_price.textContent = (per_set_price * number_of_wraps).toFixed(2);
          pick_your_colors_button_compare_price.textContent = ((product_price * number_of_wraps) / 100).toFixed(2);

          // set active styles for selected variant
          arr.forEach(item => {
            item.classList.remove("active");
          });
          item.classList.add("active");

          // toggle atc button
          if (selected_colors_array.length === number_of_wraps) {
            switchToAddToCart();
          } else {
            switchToChooseColors();
          }

          // show/hide gift for selected variant
          build_a_box_gift_items.forEach((gift_item) => {
            const gift_wraps_number = parseInt(gift_item.dataset.wrapsNumber); // number of wraps for gift item
            const image = gift_item.querySelector("img");

            if (gift_wraps_number > current_number_of_wraps) {
              image.classList.add("hidden");
            } else {
              image.classList.remove("hidden");
            }
          });
        });
      });          

      // CLICK PRE SELECTED VARIANT
      variant_picker_items[pre_selected_variant_number - 1].click();
      subscription_picker_first_item.classList.remove("opacity-0");

      // HIDE PRICE BLOCK LOADER AND SHOW PRICE BLOCK CONTENT
      price_block_loader_element.classList.add("hidden");
      price_block_content_elements.forEach((element) => {
        element.classList.remove("hidden");
        element.classList.add("flex");
      });

      // HIDE LOADER AND SHOW TEXT FOR PICK YOUR COLORS BUTTON
      pick_your_colors_button.querySelector(".loader").classList.add("hidden");
      pick_your_colors_button.querySelector(".text").classList.remove("hidden");

      // OPEN NAIL PICKER FROM SELECTED COLORS
      nail_picker_selected_colors.forEach((color) => {
        color.addEventListener("click", () => {
          hidden_overlay.classList.remove("hidden");
          document.body.style.overflow = "hidden";
          nail_picker_color_list_wrapper.classList.remove("hidden");
        });
      });

      // CLOSE NAIL PICKER
      nail_picker_color_list_close_popup.forEach((item) => {
        item.addEventListener("click", () => {
          hidden_overlay.classList.add("hidden");
          document.body.style.overflow = "auto";
          nail_picker_color_list_wrapper.classList.add("hidden");
        });
      });  

      // ADD TO CART BUTTON -- PICK YOUR COLORS BUTTON 
      pick_your_colors_button.addEventListener("click", (e) => {
        const button = e.currentTarget;
        const buttonType = button.type;        

        if (buttonType === "button") {
          hidden_overlay.classList.remove("hidden");
          document.body.style.overflow = "hidden";
          nail_picker_color_list_wrapper.classList.remove("hidden");
        } 
        
        if (buttonType === "submit") {
          pick_your_colors_button.querySelector(".loader").classList.remove("hidden");
          pick_your_colors_button.querySelector(".text").classList.add("hidden");

          fetch("/cart.js")
            .then((res) => res.json())
            .then((data) => {
              let dynamicBoxIndex = 0;
              const cartItems = data.items;

              cartItems.forEach((item) => {
                if (item.properties._dynamicBoxIndex !== undefined) {
                  dynamicBoxIndex = Math.max(dynamicBoxIndex, +item.properties._dynamicBoxIndex + 1);
                }
              });

              const gift_products_handles = [];
              build_a_box_gift_items.forEach((item, i) => {
                const img = item.querySelector("img");
                const handle = item.dataset.handle;

                if (!img.classList.contains("hidden") && i !== 0 && handle !== "none") {
                  gift_products_handles.push(handle);
                }
              });

              const payload = {
                items: [
                  ...selected_colors_array.map(id => ({
                    id: id,
                    quantity: 1,
                    ...(selected_selling_plan_id && {
                      selling_plan: selected_selling_plan_id,
                    }),
                    properties: {
                      _selling_plan_title: selected_selling_plan_title,
                      _mystery_gifts_in_cart: "true",
                      _dynamicBoxIndex: dynamicBoxIndex,
                      _dynamicBoxId: build_a_box_id,
                      ...(gift_products_handles.length > 0 && {
                        _gift_products_handles: gift_products_handles.join(","),
                      }),
                    },
                  })),
                ],
              };

              fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
              })
                .then((res) => res.json())
                .then((data) => {
                  console.log("✅ Successfully added to cart:", data);

                  onOpenDrawer();
                  updateCartDrawer(); 
                  switchToChooseColors();
                  resetPageData();
    
                  pick_your_colors_button.querySelector(".loader").classList.add("hidden");
                  pick_your_colors_button.querySelector(".text").classList.remove("hidden");
                })
                .catch((err) => console.error("❌ Error adding to cart:", err));
            })
            .catch((err) => console.error("❌ Error adding to cart:", err));          
        }        
      });
      
      function hidePlusButtons() {
        add_color_plus_buttons.forEach(button => {
          button.style.visibility = "hidden";          
        });

        add_color_plus_buttons_popup.forEach(button => {
          button.style.visibility = "hidden";
        });
      }

      function showPlusButtons() {
        add_color_plus_buttons.forEach(button => {
          button.style.visibility = "visible";
        });

        add_color_plus_buttons_popup.forEach(button => {
          button.style.visibility = "visible";
        });
      }

      // SWITCH TO ADD TO CART BUTTON
      function switchToAddToCart() {
        pick_your_colors_button.setAttribute("type", "submit");
        const buttonTextElement = pick_your_colors_button.querySelector(".text");      
        const buttonText = buttonTextElement.querySelector(".button-text");
        const buttonTextAdd = buttonTextElement.dataset.buttonTextAdd;
        buttonText.textContent = buttonTextAdd;
        hidePlusButtons();
      }

      // SWITCH TO CHOOSE COLORS BUTTON
      function switchToChooseColors() {
        pick_your_colors_button.setAttribute("type", "button");
        const buttonTextElement = pick_your_colors_button.querySelector(".text");      
        const buttonText = buttonTextElement.querySelector(".button-text");
        const buttonTextChoose = buttonTextElement.dataset.buttonTextChoose;
        buttonText.textContent = buttonTextChoose;
        showPlusButtons();
      }    

      // NAIL PICKER PRODUCTS FROM BUILD A BOX DATA
      const selectable_product_variants = build_a_box_data.DynamicBox.selectableProductVariants;
      const productIds = selectable_product_variants.map((p) =>
        p.productPlatformId.replace("gid://shopify/Product/", "")
      );

      // HIDE PRODUCTS FROM COLLECTION THAT ARE NOT IN THE BUILD A BOX
      color_items.forEach((item) => {
        const сolor_id = item.dataset.id;

        if (!productIds.includes(сolor_id)) {
          item.classList.add("hidden");
        }
      });

      // COLOR POPUP ELEMENTS
      const nail_picker_color_open_popup = document.querySelectorAll('.nail-picker-color-open-popup');
      const nail_picker_color_close_popup = document.querySelectorAll('.nail-picker-color-close-popup');
      const nail_picker_color_popup_add_buttons = document.querySelectorAll('.nail-picker-color-popup-add-button'); 

      // SLIDER INIT FOR COLOR POPUP
      let slider = null;
      function sliderInit(elementId) {
        function sliderNavigation(slider) {
          let controlsWrapper, dots, arrowLeft, arrowRight;
        
          function removeElement(el) {
            el?.parentNode?.removeChild(el);
          }
        
          function createDiv(className) {
            const div = document.createElement("div");
            className.split(" ").forEach(name => div.classList.add(name));
            return div;
          }
        
          function controlsMarkup(remove) {
            if (remove) {
              removeElement(controlsWrapper);
              return;
            }
        
            controlsWrapper = createDiv("product-image-keen-slider-navigation-controls");
        
            arrowLeft = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--left");
            arrowRight = createDiv("product-image-keen-slider-arrow product-image-keen-slider-arrow--right");
        
            arrowLeft.innerHTML = " "; 
            arrowRight.innerHTML = " ";
        
            arrowLeft.addEventListener("click", () => slider.prev());
            arrowRight.addEventListener("click", () => slider.next());
        
            controlsWrapper.appendChild(arrowLeft);
            controlsWrapper.appendChild(arrowRight);
        
            dots = createDiv("product-image-keen-slider-dots");
            const totalSlides = slider.track.details.slides.length;
        
            for (let i = 0; i < totalSlides; i++) {
              const dot = createDiv("product-image-keen-slider-dot");
              dot.addEventListener("click", () => slider.moveToIdx(i));
              dots.appendChild(dot);
            }
        
            controlsWrapper.appendChild(dots);
            slider.container.parentNode.appendChild(controlsWrapper);
          }
        
          function updateClasses() {
            const rel = slider.track.details.rel;
        
            if (dots) {
              Array.from(dots.children).forEach((dot, idx) => {
                dot.classList.toggle("product-image-keen-slider-dot--active", idx === rel);
              });
            }
        
            if (arrowLeft && arrowRight) {
              const maxIdx = slider.track.details.slides.length - 1;
              arrowLeft.classList.toggle("disabled", rel === 0);
              arrowRight.classList.toggle("disabled", rel === maxIdx);
            }
          }
        
          slider.on("created", () => {
            controlsMarkup();
            updateClasses();
          });
        
          slider.on("slideChanged", updateClasses);
          slider.on("destroyed", () => controlsMarkup(true));
        }
        
        slider = new KeenSlider(
          elementId,
          {
            loop: false,
            slides: { perView: 1, spacing: 16 }
          },
          [sliderNavigation]
        );
      };

      // OPEN NAIL PICKER COLOR POPUP
      nail_picker_color_open_popup.forEach(item => {
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const current_color = event.currentTarget;
          const data_popup_id = current_color.dataset.popupId;

          const color_popup = document.getElementById(data_popup_id);
          if (color_popup) {
            color_popup.classList.remove('hidden');
            nail_picker_color_list_wrapper.style.overflowY = 'hidden';

            const slider_container = color_popup.querySelector('.keen-slider');

            if (slider_container) {
              sliderInit(slider_container);
            }
          }      
        });
      });

      // CLOSE NAIL PICKER COLOR POPUP
      nail_picker_color_close_popup.forEach(item => { 
        item.addEventListener('click', (event) => {
          event.stopPropagation();
          const current_color = event.currentTarget;
          const data_id = current_color.dataset.id;      

          if (slider) {
            slider.destroy();
            slider = null;
          }

          const choose_color_popup = document.getElementById(data_id);
          if (choose_color_popup) {
            choose_color_popup.classList.add('hidden');
            nail_picker_color_list_wrapper.style.overflowY = 'auto';
          }
        });
      });

      // CHECK SELECTED COLOR COUNT
      function checkSelectedColor(data_id) {
        return selected_colors_array.filter((id) => id === data_id).length;
      }

      function addProduct(data_id, data_title, data_image) {
        selected_colors_array.push(data_id);

        for (const color of nail_picker_selected_colors) {
          const image = color.querySelector("img");
          if (!image.src) {
            image.src = data_image;
            image.classList.remove("hidden");
            color.querySelector("p").textContent = data_title;
            color.querySelector("span").classList.add("hidden");
            color.querySelector(".remove-selected-color").classList.remove("hidden");
            color.setAttribute("data-id", data_id);

            break;
          }
        }

        for (const color of color_list_selected_colors) {
          const image = color.querySelector("img");
          if (!image.src) {
            image.src = data_image;
            image.classList.remove("hidden");
            color.querySelector("span").classList.add("hidden");
            color.setAttribute("data-id", data_id);

            break;
          }
        }

        for (const color of selected_colors_sticky_atc) {
          const image = color.querySelector("img");
          if (!image.src) {
            image.src = data_image;
            image.classList.remove("hidden");
            color.querySelector("span").classList.add("hidden");
            color.setAttribute("data-id", data_id);

            break;
          }
        }
      }

      // ADD COLOR TO PICKER FROM COLOR LIST
      color_items.forEach((color_item) => {
        const add_color_item_button = color_item.querySelector(".add-color-item-button");
        if (add_color_item_button) {
          add_color_item_button.addEventListener("click", () => {
            const current_color = color_item;
            const data_id = current_color.dataset.variantId;
            const data_title = current_color.dataset.title;
            const data_image = current_color.dataset.image;

            if (selected_colors_array.length < current_number_of_wraps) {
              current_color.querySelector(".quantity-color-item-wrapper").classList.remove("hidden");

              addProduct(data_id, data_title, data_image);

              const current_color_img = current_color.querySelector('.nail-picker-color-image-wrapper');
              current_color_img.classList.add('selected-color-item');

              const color_count = checkSelectedColor(data_id);
              const color_item_count = current_color.querySelector(".color-item-count");
              color_item_count.textContent = color_count;

              if (selected_colors_array.length === current_number_of_wraps) {
                switchToAddToCart();

                hidden_overlay.classList.add("hidden");
                document.body.style.overflow = "auto";
                nail_picker_color_list_wrapper.classList.add("hidden");
              }
            }
          });
        }

        const add_color_item_button_plus = color_item.querySelector(".color-item-count-plus");
        if (add_color_item_button_plus) {
          add_color_item_button_plus.addEventListener("click", () => {
            const current_color = color_item;
            const data_id = current_color.dataset.variantId;
            const data_title = current_color.dataset.title;
            const data_image = current_color.dataset.image;

            if (selected_colors_array.length < current_number_of_wraps) {
              addProduct(data_id, data_title, data_image);

              const color_count = checkSelectedColor(data_id);
              const color_item_count = current_color.querySelector(".color-item-count");

              if (color_item_count) {
                color_item_count.textContent = color_count;
              }
            }

            if (selected_colors_array.length === current_number_of_wraps) {
              switchToAddToCart();

              hidden_overlay.classList.add("hidden");
              document.body.style.overflow = "auto";
              nail_picker_color_list_wrapper.classList.add("hidden");
            }
          });
        }
      });

      // ADD COLOR TO PICKER FROM COLOR POPUP
      nail_picker_color_popup_add_buttons.forEach(item => {
        item.addEventListener('click', (event) => {
          const current_color = event.currentTarget;
          const data_id = current_color.dataset.id;
          const data_title = current_color.dataset.title;
          const data_image = current_color.dataset.image;
          const data_popup_id = current_color.dataset.popupId;

          if (selected_colors_array.length < current_number_of_wraps) {
            addProduct(data_id, data_title, data_image);

            const color_item = document.querySelector(`.nail-picker-color[data-variant-id="${data_id}"]`);
            color_item.querySelector(".quantity-color-item-wrapper").classList.remove("hidden");

            const color_count = checkSelectedColor(data_id);
            const color_item_count = color_item.querySelector(".color-item-count");
            color_item_count.textContent = color_count;

            if (selected_colors_array.length === current_number_of_wraps) {
              switchToAddToCart();

              hidden_overlay.classList.add("hidden");
              document.body.style.overflow = "auto";
              nail_picker_color_list_wrapper.classList.add("hidden");
            }

            const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');
            current_color_img.classList.add('selected-color-item');
          }
          
          const color_popup = document.getElementById(data_popup_id);
          color_popup.classList.add('hidden');

          if (slider) {
            slider.destroy();
            slider = null;
          }
        });
      }); 

      // REMOVE BUTTONS ON COLOR ITEMS LIST
      const remove_selected_color_items = document.querySelectorAll(".remove-selected-color-item");
      remove_selected_color_items.forEach((item) => {
        item.addEventListener("click", (event) => {
          event.stopPropagation();
          const current_item = event.currentTarget;
          const parent = current_item.closest(".nail-picker-color");
          const data_id = current_item.dataset.id;

          selected_colors_array.splice(selected_colors_array.indexOf(data_id), 1);

          if (checkSelectedColor(data_id) === 0) {
            parent.querySelector(".quantity-color-item-wrapper").classList.add("hidden");

            const current_color_img = parent.querySelector('.nail-picker-color-image-wrapper');
            current_color_img.classList.remove('selected-color-item');
          }

          const color_item_count = parent.querySelector(".color-item-count");
          const color_count = checkSelectedColor(data_id);
          color_item_count.textContent = color_count;

          const nail_picker_selected_colors_reversed = [...nail_picker_selected_colors].reverse();
          for (const color of nail_picker_selected_colors_reversed) {
            const id = color.dataset.id;
            const default_title = color.dataset.defaultTitle;

            if (id === data_id) {
              const image = color.querySelector("img");
              image.removeAttribute("src");
              image.classList.add("hidden");

              color.removeAttribute("data-id");

              color.querySelector("p").textContent = default_title;
              color.querySelector("span").classList.remove("hidden");
              color.querySelector(".remove-selected-color").classList.add("hidden");

              break;
            }
          }

          const color_list_selected_colors_reversed = [...color_list_selected_colors].reverse();
          for (const color of color_list_selected_colors_reversed) {
            const id = color.dataset.id;

            if (id === data_id) {
              const image = color.querySelector("img");
              image.removeAttribute("src");
              image.classList.add("hidden");

              color.removeAttribute("data-id");
              color.querySelector("span").classList.remove("hidden");

              break;
            }
          }

          const selected_colors_sticky_atc_reversed = [...selected_colors_sticky_atc].reverse();
          for (const color of selected_colors_sticky_atc_reversed) {
            const id = color.dataset.id;

            if (id === data_id) {
              const image = color.querySelector("img");
              image.removeAttribute("src");
              image.classList.add("hidden");

              color.removeAttribute("data-id");
              color.querySelector("span").classList.remove("hidden");

              break;
            }
          }

          switchToChooseColors();
        });
      });

      // REMOVER FROM SELECTED COLORS
      const remove_selected_colors = document.querySelectorAll(".remove-selected-color");
      remove_selected_colors.forEach((item, index) => {
        item.addEventListener("click", (event) => {
          event.stopPropagation();
          const current_item = event.currentTarget;
          const parent = current_item.closest(".nail-picker-selected-color");
          const data_id = parent.dataset.id;

          selected_colors_array.splice(selected_colors_array.indexOf(data_id), 1);          

          for (const color of color_items) {
            const id = color.dataset.variantId;

            if (id === data_id) {
              const color_count = checkSelectedColor(data_id);

              if (color_count === 0) {
                color.querySelector(".quantity-color-item-wrapper").classList.add("hidden");
                const current_color_img = color.querySelector('.nail-picker-color-image-wrapper');
                current_color_img.classList.remove('selected-color-item');
              }

              const color_item_count = color.querySelector(".color-item-count");
              color_item_count.textContent = color_count;

              break;
            }
          }

          const current_color_for_remove = nail_picker_selected_colors[index];
          const default_title = current_color_for_remove.dataset.defaultTitle;
          current_color_for_remove.removeAttribute("data-id");
          current_color_for_remove.querySelector("img").removeAttribute("src");
          current_color_for_remove.querySelector("img").classList.add("hidden");
          current_color_for_remove.querySelector("p").textContent = default_title;
          current_color_for_remove.querySelector("span").classList.remove("hidden");
          current_color_for_remove.querySelector(".remove-selected-color").classList.add("hidden");

          const current_picker_color_for_remove = color_list_selected_colors[index];
          current_picker_color_for_remove.removeAttribute("data-id");
          current_picker_color_for_remove.querySelector("img").removeAttribute("src");
          current_picker_color_for_remove.querySelector("img").classList.add("hidden");
          current_picker_color_for_remove.querySelector("span").classList.remove("hidden");

          const current_sticky_color_for_remove = selected_colors_sticky_atc[index];
          current_sticky_color_for_remove.removeAttribute("data-id");
          current_sticky_color_for_remove.querySelector("img").removeAttribute("src");
          current_sticky_color_for_remove.querySelector("img").classList.add("hidden");
          current_sticky_color_for_remove.querySelector("span").classList.remove("hidden");

          switchToChooseColors();
        });
      });

      // GUARANTEE POPUP ELEMENTS
      const guarantee_popup_open_button = document.getElementById("guarantee-popup-open-button");
      const guarantee_popup_content = document.getElementById("guarantee-popup-content");
      const guarantee_popup_close_buttons = document.querySelectorAll(".guarantee-popup-close-button");

      // OPEN GUARANTEE POPUP
      if (guarantee_popup_open_button && guarantee_popup_content) {
        guarantee_popup_open_button.addEventListener("click", () => {
          guarantee_popup_content.classList.remove("hidden");
        });
      }

      // CLOSE GUARANTEE POPUP
      if (guarantee_popup_close_buttons && guarantee_popup_content) {
        guarantee_popup_close_buttons.forEach((item) => {
          item.addEventListener("click", () => {
            guarantee_popup_content.classList.add("hidden");
          });
        });
      }

      // RESET PAGE DATA AFTER ADD TO CART
      function resetPageData() {
        selected_colors_array.length = 0;     

        for (const color of selected_colors_last_step) {
          color.removeAttribute("data-id");
          color.querySelector("img").removeAttribute("src");
          color.querySelector("img").classList.add("hidden");
          color.querySelector(".lock-icon").classList.remove("hidden");
          color.querySelector(".remove-selected-color-on-last-step").classList.add("hidden");
        }

        for (const color of nail_picker_selected_colors) {
          const default_title = color.dataset.defaultTitle;

          const image = color.querySelector("img");
          image.removeAttribute("src");
          image.classList.add("hidden");

          color.removeAttribute("data-id");

          color.querySelector("p").textContent = default_title;
          color.querySelector("span").classList.remove("hidden");
          color.querySelector(".remove-selected-color").classList.add("hidden");
        }

        for (const color of color_list_selected_colors) {
          const image = color.querySelector("img");
          image.removeAttribute("src");
          image.classList.add("hidden");

          color.removeAttribute("data-id");

          color.querySelector("span").classList.remove("hidden");
        }

        for (const color of selected_colors_sticky_atc) {
          const image = color.querySelector("img");
          image.removeAttribute("src");
          image.classList.add("hidden");

          color.removeAttribute("data-id");

          color.querySelector("span").classList.remove("hidden");
        }

        color_items.forEach(color_item => {
          const color_item_count = color_item.querySelector('.color-item-count');
          if (color_item_count) {
            color_item_count.textContent = 0;
          }
    
          const quantity_color_item_wrapper = color_item.querySelector('.quantity-color-item-wrapper');
          if (quantity_color_item_wrapper) {
            quantity_color_item_wrapper.classList.add('hidden');
          }
    
          const add_color_item_button = color_item.querySelector('.add-color-item-button');
          if (add_color_item_button) {
            add_color_item_button.classList.remove('hidden');
          }
    
          const current_color_img = color_item.querySelector('.nail-picker-color-image-wrapper');
          current_color_img.classList.remove('selected-color-item');
        });

        variant_picker_items[pre_selected_variant_number - 1].click();
      }
    })
    .catch((error) => console.error("Error:", error));
});
